import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../assets/css/DigixLeads.css";
import "../assets/css/HRManagement.css";

export const TAB_RECRUITMENT = "Add recruitment";
export const TAB_TIME = "Time management";

/** `location.state.hrTab`: "recruitment" | "time" (from Dashboard links). */
function tabFromRouteState(hrTab) {
  if (hrTab === "time") return TAB_TIME;
  return TAB_RECRUITMENT;
}

/**
 * HR Management — sidebar module with tabs matching Digix Leads tab styling.
 */
function HRManagement() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() =>
    tabFromRouteState(location.state?.hrTab)
  );

  useEffect(() => {
    const hrTab = location.state?.hrTab;
    if (hrTab === "recruitment" || hrTab === "time") {
      setActiveTab(tabFromRouteState(hrTab));
    }
  }, [location.state?.hrTab, location.key]);

  return (
    <div className="digixleads-container hr-management-page">
      <div className="main-card">
        <div className="page-header">
          <div className="page-header-row">
            <div className="tabs-container">
              <button
                type="button"
                className={`tab-button ${activeTab === TAB_RECRUITMENT ? "active" : ""}`}
                onClick={() => setActiveTab(TAB_RECRUITMENT)}
              >
                Add recruitment
              </button>
              <button
                type="button"
                className={`tab-button ${activeTab === TAB_TIME ? "active" : ""}`}
                onClick={() => setActiveTab(TAB_TIME)}
              >
                Time management
              </button>
            </div>
          </div>
        </div>

        <div className="hr-management-tab-body">
          {activeTab === TAB_RECRUITMENT && (
            <div className="hr-management-placeholder">
              <p>Add recruitment — content coming soon.</p>
            </div>
          )}
          {activeTab === TAB_TIME && (
            <div className="hr-management-placeholder">
              <p>Time management — content coming soon.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HRManagement;
